import { middleWareWrapper } from './middleware-utils';
import { cmxTypeguards } from '@codametrix/ui-common';
import { jumpContext } from '../../actions/contexts.action';
export const contextMiddlewareProcessor = (api, next, action)=>{
    if (!cmxTypeguards.isReduxAction(action)) {
        return next(action);
    }
    switch(`${action.type}`){
        case jumpContext.pending.type:
            // Try supported APIs to clear the global context
            // @ts-ignore
            const dd_rum = window.DD_RUM || {
                clearGlobalContext: ()=>{}
            };
            dd_rum.clearGlobalContext();
            // Use unsupported APIs to clear the session cookie
            // This code is brittle and will break if the cookie name changes.
            // However, the DD provided APIsdo not change the user session attribute in the cookie.
            document.cookie = '_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; path=/; domain=' + window.location.hostname;
            document.cookie = '_dd_s=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; path=/;';
            return next(action);
    }
    return next(action);
};
const contextMiddleware = middleWareWrapper(contextMiddlewareProcessor);
export default contextMiddleware;
